<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <iframe title="Survey" class="survey-iframe" height="800px" width="100%"
            :src="surveyUrl+'?ChatbotId='+chatbotId"></iframe>
  </v-dialog>
</template>
<script>
export default {
  props: {
    surveyUrl: {
      type: String,
      default: '',
    },
    chatbotId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      dialog: false,
      surveyCompleted: false
    }
  },
  watch: {
    dialog(newValue, oldValue) {
      if (!newValue && oldValue){
        this.saveSurvey(this.chatbotId, this.surveyCompleted)
      }
    }
  },
  beforeCreate() {
    window.addEventListener('message', (e) => {
      this.surveyCompleted = true
      if (this.surveyUrl.startsWith(e.origin) && e.data === 'closeQSIWindow') {
        setTimeout(() => this.dialog = false, 3.5 * 1000)
      }
    });
  },
  mounted() {
    if (this.surveyUrl) {
      this.showSurvey();
    }
  },
  methods: {
    showSurvey() {
      this.dialog = true;
    },
    async saveSurvey(chatbotId, surveyCompleted){
      await this.$axios.post(`/survey/${chatbotId}`, {complete:surveyCompleted});
    }
  }
}
</script>
<style>
.survey-iframe {
  border: 0;
  margin-left: auto;
  margin-right: auto;
}
</style>
